import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=734beada&scoped=true&"
var script = {}
import style0 from "./app-footer.vue?vue&type=style&index=0&id=734beada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734beada",
  null
  
)

export default component.exports